import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  env : any = environment
  constructor() {
    // Initialize PostHog with type assertion to avoid FontFace issues
    
    const posthogKey = this.env?.POSTHOG_KEY;

    if (posthogKey) {
      (posthog as any).init((this.env.POSTHOG_KEY || ''), {
        api_host: (this.env.POSTHOG_HOST || ''),
        disable_compression: true,
        capture_pageview: false,
        autocapture: false,
        person_profiles: 'identified_only', 
        persistence: 'localStorage',
        _capture_metrics: false,
        loaded: (ph: any) => {
          if (environment.production) {
            ph.debug(false);
          } else {
            ph.debug(true);
          }
        }
      });
    }

    
  }

  // Track custom events
  captureEvent(eventName: string, properties?: Record<string, any>): void {
    (posthog as any).capture(eventName, properties);
  }

  // Identify users
  identify(userId: string, properties?: Record<string, any>): void {
    (posthog as any).identify(userId, properties);
  }

  // Reset user
  reset(): void {
    (posthog as any).reset();
  }

  // Get distinct ID
  getDistinctId(): string {
    return (posthog as any).get_distinct_id();
  }

  // Track page views manually if needed
  trackPageView(properties?: Record<string, any>): void {
    return;
    (posthog as any).capture('$pageview', properties);
  }
} 